import { FLOW_CONDITION_TYPES } from '../constants';
import { FlowConditionAppValuationReportNew } from './types.flow';

export default (): Omit<FlowConditionAppValuationReportNew, 'id'> => ({
  type: FLOW_CONDITION_TYPES.APPVALUATIONREPORT_NEW.type,
  app: null,
});
